/* istanbul ignore file */
import { DoneIcon, ErrorIcon as ErrorIconSvg } from '@econsult/econsult-ui/dist/assets';
import { ToastContainer as UnstyledToastContainer, FadeInFadeOut } from '@econsult/econsult-ui/dist/components/Toast';
import styled from 'styled-components';

export const SuccessTick = styled(DoneIcon)`
  height: 20px;
  width: 20px;
  margin-right: 8px;
  color: ${({ theme }) => theme.colorBrightWhite};
`;

export const ErrorIcon = styled(SuccessTick).attrs({ as: ErrorIconSvg })``;

export const ToastContainer = styled(UnstyledToastContainer)`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
`;

export const ToastContainerWrapper = styled.div`
  && .Toastify__toast--default {
    padding: 0 !important;
    margin: 0 !important;
  }

  && .Toastify__toast--success {
    background: ${({ theme }) => theme.colorStatusSuccess};
    padding: 8px !important;
  }

  && .Toastify__toast--error {
    background: ${({ theme }) => theme.colorStatusError};
    padding: 8px !important;
  }

  && .Toastify__toast--warning {
    background: ${({ theme }) => theme.colorStatusWarning};
    padding: 8px !important;
  }

  && .Toastify__toast-container--bottom-left {
    left: 1rem;
    bottom: 1rem;
    padding-bottom: 0;
  }

  && .Toastify__toast-container--bottom-center {
    bottom: 3rem;
    padding-bottom: 0;
  }
`;

export const ToastMessage = styled.div`
  display: flex;
  align-items: center;
  margin: 4px;
`;

export { FadeInFadeOut };
